import { ServerImageInfo } from '@/api/type-server'
import { Button, Modal, Trans } from '@/components'

interface RestoreImageModalProps {
  open: boolean
  image: ServerImageInfo | null
  loading?: boolean
  onClose: () => void
  onConfirm: (image: ServerImageInfo) => void
}

export function RestoreImageModal({
  open,
  image,
  loading,
  onClose,
  onConfirm,
}: RestoreImageModalProps) {
  if (!open || !image) return null

  return (
    <Modal
      className="w-[480px]"
      open={true}
      onClose={() => {
        if (!loading) onClose()
      }}
    >
      <Modal.Header>
        <Trans i18nKey="customImage.restoreModal.title">Restore Image</Trans>
      </Modal.Header>
      <Modal.Body>
        <div className="t-sm text-primary">
          <Trans i18nKey="customImage.restoreModal.description">
            This image will be restored and time-based billing will resume. Please confirm to
            proceed.
          </Trans>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="outline" disabled={loading} onClick={onClose}>
          <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
        </Button>
        <Button type="secondary" disabled={loading} onClick={() => onConfirm(image)}>
          <Trans i18nKey="customImage.restoreModal.confirmButton">Restore</Trans>
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
